import type { JavascriptRequestDataModel, UserContextViewModel } from 'autogen/swagger/all';
import { useJavascriptRequestDataModelQuery } from 'autogen/swagger/all/hooks';

export default function useUserContext(): UserContextViewModel {
    const { data } = useJavascriptRequestDataModelQuery({ enabled: false });
    return (data as JavascriptRequestDataModel).userContextModel;
}
